import http from "@/utils/http";
export default{
    submitButtonLoadingStatus({commit},payload){
        console.log(payload)
    },
    async fetchSupervisorNotifications({ commit }) {
        const endpoint = `/all-leads-edit-requests`;
        const method = "get";
        try {
          const response = await http[method](endpoint);
          commit('setSupervisorNotifications', response.data.contents); // Commit the notifications data
        } catch (error) {
          console.error("Error fetching notifications:", error);
        }
    },
    async fetchRolePermissions({ commit }) {
      try {
        const response = await http.get("get-role-permissions");

        if (response.data.contents.permissions) {
          commit("setUser", response.data.contents.user);
          commit("setUserRoles", response.data.contents.roles);
          commit("setUserPermissions", response.data.contents.permissions);
        }
      } catch (error) {
        console.error("Error fetching role permissions:", error);
      }
    },


}
